export const iconFontAwesomeShoppingBtc = (
	<i className="fa-solid fa-btc"></i>
);
